import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./css/negomod.css";
import { apiPut, apiGet } from "../../../utils/apiClient";
import {
  formatDateToInput,
  calculateEndDateTime,
  parseTimeToDate,
  formatTimeToString,
} from "../../../utils/commonService";

const getTimeFromDateTime = (dateTime) => {
  if (!dateTime) return "";
  const date = new Date(dateTime);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

const NegoMod = ({ nego, onClose, onRefresh }) => {
  const [startDate, setStartDate] = useState(formatDateToInput(nego.startDateTime));
  const [startTime, setStartTime] = useState(getTimeFromDateTime(nego.startDateTime));
  const [endDateTime, setEndDateTime] = useState("");
  const [negoTimeout, setNegoTimeout] = useState(24);

  useEffect(() => {
    const fetchTimeout = async () => {
      try {
        const response = await apiGet("/store/sale/time");
        if (response.ok) {
          const limitTime = await response.json();
          setNegoTimeout(limitTime);
        }
      } catch (error) {
        console.error("네고 제한 시간 조회 실패:", error);
      }
    };
    fetchTimeout();
  }, []);

  useEffect(() => {
    if (startDate && startTime) {
      setEndDateTime(calculateEndDateTime(startDate, startTime, negoTimeout));
    }
  }, [startDate, startTime, negoTimeout]);

  const handleDateTimeChange = (date, time) => {
    if (date) setStartDate(date);
    if (time) setStartTime(time);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!startDate || !startTime) {
      alert("네고 시작 날짜와 시간을 입력해주세요.");
      return;
    }

    const selectedStartDateTime = new Date(`${startDate}T${startTime}:00`);
    const currentDateTime = new Date();

    if (selectedStartDateTime < currentDateTime) {
      alert("네고 시작 시간은 현재 시간보다 이전일 수 없습니다.");
      return;
    }

    try {
      const requestData = {
        startDateTime: `${startDate}T${startTime}:00`,
      };

      const response = await apiPut(`/store/nego/${nego.negoIdx}`, requestData);

      if (response.ok) {
        alert("네고가 성공적으로 수정되었습니다.");
        if (onRefresh) {
          onRefresh();
        }
        onClose();
      } else {
        const errorData = await response.json();
        alert(errorData.message || "네고 수정에 실패했습니다.");
      }
    } catch (err) {
      console.error("네고 수정 실패:", err);
      alert("네고 수정 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="nego-mod-backdrop">
      <div className="nego-mod-wrap">
        <div className="nego-mod-header">네고 수정</div>

        <div className="nego-mod-body">
          <form className="nego-mod-form" onSubmit={handleSubmit}>
            <div className="nego-mod-date">
              <label>네고 시작 일자</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => handleDateTimeChange(e.target.value, startTime)}
              />
              <label>네고 시작 시간</label>
              <DatePicker
                selected={parseTimeToDate(startTime)}
                onChange={(date) => {
                  const timeString = formatTimeToString(date);
                  handleDateTimeChange(startDate, timeString);
                }}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={30}
                timeCaption="시간"
                dateFormat="HH:mm"
                timeFormat="HH:mm"
                className="nego-mod-time-input"
                popperPlacement="right-start"
              />
            </div>

            <div className="nego-mod-end">
              <label>네고 종료 일시</label>
              <input
                type="text"
                value={endDateTime}
                readOnly
                placeholder="자동 계산됨"
              />
              <small className="nego-mod-time-hint">
                ⓘ 네고 시작 일시에 따라 자동 계산됩니다
              </small>
            </div>

            <div className="nego-mod-buttons">
              <button type="submit" className="nego-mod-submit">
                수정
              </button>
              <button
                type="button"
                className="nego-mod-cancel"
                onClick={onClose}
              >
                취소
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NegoMod;
